(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["apps"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const widgetSelector = '#judgeme_product_reviews';
    const reviewsSelector = '.jdgm-rev-widg__reviews';
    const reviewSelector = ':scope > .jdgm-rev';
    const reviewFormSelector = '.jdgm-form-wrapper';
    const writeReviewSelector = '.jdgm-write-rev-link';
    const modalState = new WeakMap();
    const pendingModalTriggers = new WeakMap();

    const icon = (direction) => {
      const points = direction === 'previous' ? '15 18 9 12 15 6' : '9 18 15 12 9 6';
      return `<svg aria-hidden="true" viewBox="0 0 24 24" fill="none"><polyline points="${points}" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></polyline></svg>`;
    };

    const structureReviewCards = (cards) => {
      const dateFormatter = new Intl.DateTimeFormat(document.documentElement.lang || 'en', {
        month: 'long',
        day: 'numeric',
        year: 'numeric',
      });

      cards.forEach((card) => {
        const header = card.querySelector('.jdgm-rev__header');
        const location = card.querySelector('.jdgm-rev__location');
        const timestamp = card.querySelector('.jdgm-rev__timestamp');
        if (!header || (!location && !timestamp)) return;

        if (timestamp && timestamp.dataset.hbcDateFormatted !== 'true') {
          const rawDate = (timestamp.dataset.content || timestamp.textContent).trim();
          const numericDate = rawDate.match(/^(\d{1,2})\/(\d{1,2})\/(\d{4})$/);
          const parsedDate = numericDate
            ? new Date(Number(numericDate[3]), Number(numericDate[1]) - 1, Number(numericDate[2]))
            : new Date(rawDate);
          if (!Number.isNaN(parsedDate.getTime())) {
            timestamp.textContent = dateFormatter.format(parsedDate);
            timestamp.dataset.hbcDateFormatted = 'true';
          }
        }

        let metadata = header.querySelector(':scope > .hbc-review-card__meta');
        if (!metadata) {
          metadata = document.createElement('div');
          metadata.className = 'hbc-review-card__meta';
          header.append(metadata);
        }
        [location, timestamp].forEach((element) => {
          if (element && element.parentElement !== metadata) metadata.append(element);
        });
      });
    };

    const structureOverview = (widget) => {
      const appSection = widget.closest('.hbc-app-section');
      const widgetInner = widget.querySelector('.jdgm-rev-widg') || widget;
      const actions = widget.querySelector('.jdgm-widget-actions-wrapper');
      if (!appSection || !actions) return;

      let sectionHeader = widgetInner.querySelector(':scope > .hbc-review-section-header');
      if (!sectionHeader) {
        sectionHeader = document.createElement('div');
        sectionHeader.className = 'hbc-review-section-header';
        const copy = document.createElement('div');
        const title = document.createElement('h2');
        const description = document.createElement('p');
        copy.className = 'hbc-review-section-header__copy';
        title.className = 'hbc-review-section-header__title';
        description.className = 'hbc-review-section-header__description';
        copy.append(title, description);
        sectionHeader.append(copy);
        const body = widgetInner.querySelector('.jdgm-rev-widg__body');
        widgetInner.insertBefore(sectionHeader, body || widgetInner.firstChild);
      }

      sectionHeader.querySelector('.hbc-review-section-header__title').textContent =
        appSection.dataset.reviewSectionHeading.replaceAll('&amp;', '&');
      sectionHeader.querySelector('.hbc-review-section-header__description').textContent =
        appSection.dataset.reviewSectionDescription;
      if (actions.parentElement !== sectionHeader) sectionHeader.append(actions);
      const writeReview = actions.querySelector(writeReviewSelector);
      if (writeReview) writeReview.textContent = appSection.dataset.reviewWrite;
    };

    const customizeReviewForm = (wrapper, appSection) => {
      if (wrapper.dataset.hbcModalStyled === 'true') return;

      const form = wrapper.querySelector('form') || wrapper;
      const fieldFor = (element) => element?.closest('.jdgm-form__fieldset') || element?.parentElement;
      const setField = (input, label, placeholder) => {
        if (!input) return;
        const field = fieldFor(input);
        const fieldLabel = field?.querySelector('label');
        if (fieldLabel) fieldLabel.textContent = label;
        input.placeholder = placeholder;
      };
      const heading = form.querySelector('.jdgm-form__title');
      const rating = form.querySelector('.jdgm-form__rating');
      const nameInput = form.querySelector(
        'input:not([type="hidden"])[name*="reviewer_name" i], input:not([type="hidden"])[name*="name" i], input:not([type="hidden"])[id*="name" i]'
      );
      const emailInput = form.querySelector('input[type="email"], input[name*="email" i]');
      const titleInput = form.querySelector(
        'input:not([type="hidden"])[name*="review_title" i], input:not([type="hidden"])[name*="title" i], input:not([type="hidden"])[id*="title" i]'
      );
      const bodyInput = form.querySelector('textarea[name*="body" i], textarea');
      const submit = form.querySelector('.jdgm-submit-rev, [type="submit"]');
      const ratingField = fieldFor(rating);
      const nameField = fieldFor(nameInput);
      const emailField = fieldFor(emailInput);
      const titleField = fieldFor(titleInput);
      const bodyField = fieldFor(bodyInput);

      if (!heading || !rating || !nameField || !titleField || !bodyField || !submit) return;

      heading.textContent = appSection.dataset.reviewHeading;
      const description = document.createElement('p');
      description.className = 'hbc-review-modal__description';
      description.textContent = appSection.dataset.reviewDescription;
      heading.after(description);

      setField(nameInput, appSection.dataset.reviewName, appSection.dataset.reviewNamePlaceholder);
      setField(
        emailInput,
        appSection.dataset.reviewEmail || 'Your Email *',
        appSection.dataset.reviewEmailPlaceholder || 'e.g. meera@example.com'
      );
      setField(titleInput, appSection.dataset.reviewTitle, appSection.dataset.reviewTitlePlaceholder);
      setField(bodyInput, appSection.dataset.reviewBody, appSection.dataset.reviewBodyPlaceholder);

      const identity = document.createElement('div');
      identity.className = 'hbc-review-modal__identity';
      const locationField = document.createElement('div');
      locationField.className = 'hbc-review-modal__field';
      const locationLabel = document.createElement('label');
      const locationInput = document.createElement('input');
      const locationId = `HbcReviewLocation-${Math.random().toString(36).slice(2)}`;
      locationLabel.className = 'hbc-review-modal__field-label';
      locationLabel.htmlFor = locationId;
      locationLabel.textContent = appSection.dataset.reviewLocation;
      locationInput.id = locationId;
      locationInput.className = 'hbc-review-modal__field-input';
      locationInput.type = 'text';
      locationInput.autocomplete = 'address-level2';
      locationInput.placeholder = appSection.dataset.reviewLocationPlaceholder;
      locationField.append(locationLabel, locationInput);
      identity.append(nameField, locationField);

      const ratingLabel = ratingField?.querySelector('label');
      const ratingButtons = [...rating.querySelectorAll('.jdgm-star')];
      ratingButtons.forEach((button, index) => {
        button.dataset.hbcRating = String(index + 1);
        button.addEventListener('click', () => {
          ratingButtons.forEach((item, itemIndex) => item.classList.toggle('hbc-rating-selected', itemIndex <= index));
        });
      });
      if (ratingLabel) ratingLabel.textContent = ratingLabel.textContent.trim();

      form
        .querySelectorAll('input[type="file"], input[type="url"], input[name*="youtube" i], input[id*="youtube" i]')
        .forEach((input) => {
          fieldFor(input)?.classList.add('hbc-review-modal__optional-hidden');
        });
      if (emailField) emailField.classList.remove('hbc-review-modal__optional-hidden');
      form.querySelectorAll('.jdgm-form__fieldset > p').forEach((paragraph) => {
        fieldFor(paragraph)?.classList.add('hbc-review-modal__privacy');
      });

      if (emailField) {
        description.after(ratingField, identity, emailField, titleField, bodyField);
      } else {
        description.after(ratingField, identity, titleField, bodyField);
      }

      if (submit.tagName === 'INPUT') {
        submit.value = appSection.dataset.reviewSubmit;
      } else {
        submit.textContent = appSection.dataset.reviewSubmit;
      }

      wrapper.dataset.hbcModalStyled = 'true';
    };

    const setupReviewModal = (widget) => {
      const appSection = widget.closest('.hbc-app-section');
      if (!appSection) return;
      let state = modalState.get(widget);
      const form =
        widget.querySelector(reviewFormSelector) || state?.content.querySelector(reviewFormSelector) || state?.form;
      if (!form) return;
      customizeReviewForm(form, appSection);

      if (!state) {
        document.querySelectorAll('.hbc-review-modal').forEach((existing) => {
          if (!modalState.has(widget) || modalState.get(widget)?.modal !== existing) {
            existing.remove();
          }
        });
        const placeholder = document.createComment('review-form');
        const modal = document.createElement('div');
        modal.className = 'hbc-review-modal';
        modal.setAttribute('role', 'presentation');
        const writeReview = widget.querySelector(writeReviewSelector);
        const modalLabel = appSection.dataset.reviewHeading || writeReview?.textContent.trim() || document.title;
        const closeLabel = appSection?.dataset.modalClose || 'Close';
        modal.innerHTML = `
          <div class="hbc-review-modal__dialog" role="dialog" aria-modal="true" tabindex="-1">
            <button class="hbc-review-modal__close" type="button">
              <svg aria-hidden="true" viewBox="0 0 24 24" fill="none"><path d="M6 6l12 12M18 6 6 18" stroke="currentColor" stroke-width="2" stroke-linecap="round"></path></svg>
            </button>
            <div class="hbc-review-modal__content"></div>
            <div class="hbc-review-modal__success" role="status" aria-live="polite" hidden>
              <h2 class="hbc-review-modal__success-title"></h2>
              <p class="hbc-review-modal__description"></p>
              <p class="hbc-review-modal__success-message"></p>
            </div>
          </div>
        `;
        modal.querySelector('.hbc-review-modal__dialog').setAttribute('aria-label', modalLabel);
        modal.querySelector('.hbc-review-modal__close').setAttribute('aria-label', closeLabel);
        modal.querySelector('.hbc-review-modal__success-title').textContent = appSection.dataset.reviewHeading;
        modal.querySelector('.hbc-review-modal__success .hbc-review-modal__description').textContent =
          appSection.dataset.reviewDescription;
        modal.querySelector('.hbc-review-modal__success-message').textContent = appSection.dataset.reviewSuccess;
        const targetContainer = widget.querySelector('.jdgm-rev-widg') || widget;
        targetContainer.append(modal);

        state = {
          modal,
          dialog: modal.querySelector('.hbc-review-modal__dialog'),
          content: modal.querySelector('.hbc-review-modal__content'),
          success: modal.querySelector('.hbc-review-modal__success'),
          placeholder,
          form,
          lastFocus: null,
        };
        modalState.set(widget, state);

        const open = (trigger) => {
          if (state.modal.hasAttribute('open') || state.submitted) return;
          window.clearTimeout(state.resetTimer);
          state.content.hidden = false;
          state.success.hidden = true;
          state.modal.classList.remove('hbc-review-modal--success');
          state.lastFocus = trigger || document.activeElement;
          state.form.style.setProperty('display', 'block', 'important');
          state.modal.setAttribute('open', '');
          document.body.classList.add('hbc-review-modal-open');
          window.requestAnimationFrame(() => state.dialog.focus({ preventScroll: true }));
        };

        const close = () => {
          if (!state.modal.hasAttribute('open')) return;
          window.clearTimeout(state.successTimer);
          state.modal.removeAttribute('open');
          state.form.style.setProperty('display', 'none', 'important');
          document.body.classList.remove('hbc-review-modal-open');
          state.lastFocus?.focus({ preventScroll: true });
          state.resetTimer = window.setTimeout(() => {
            state.content.hidden = state.submitted;
            state.success.hidden = true;
            state.modal.classList.remove('hbc-review-modal--success');
          }, 200);
        };

        const showSuccess = () => {
          if (state.submitted) return;
          state.submitted = true;
          window.clearTimeout(state.resetTimer);
          window.clearTimeout(state.successTimer);
          state.form.style.setProperty('display', 'none', 'important');
          state.content.hidden = true;
          state.success.hidden = false;
          state.modal.classList.add('hbc-review-modal--success');
          state.modal.setAttribute('open', '');
          document.body.classList.add('hbc-review-modal-open');
          window.requestAnimationFrame(() => state.dialog.focus({ preventScroll: true }));
          state.successTimer = window.setTimeout(close, 2600);
        };

        state.open = open;
        state.close = close;
        state.showSuccess = showSuccess;
        modal.querySelector('.hbc-review-modal__close').addEventListener('click', () => close());
        modal.addEventListener('click', (event) => {
          if (event.target === modal) close();
        });
        modal.addEventListener('keydown', (event) => {
          if (event.key === 'Escape') {
            event.preventDefault();
            close();
            return;
          }

          if (event.key !== 'Tab') return;
          const focusable = [
            ...modal.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'),
          ].filter((element) => !element.disabled && element.getClientRects().length);
          if (!focusable.length) return;
          const first = focusable[0];
          const last = focusable[focusable.length - 1];
          if (event.shiftKey && document.activeElement === first) {
            event.preventDefault();
            last.focus();
          } else if (!event.shiftKey && document.activeElement === last) {
            event.preventDefault();
            first.focus();
          }
        });

        state.form.parentNode.insertBefore(state.placeholder, state.form);
        state.content.append(state.form);
        state.form.style.setProperty('display', 'none', 'important');
      } else if (!state.submitted && state.form !== form && !state.modal.contains(form)) {
        const wasOpen = state.modal.hasAttribute('open') && !state.submitted;
        state.form = form;
        customizeReviewForm(state.form, appSection);
        state.content.replaceChildren(state.form);
        state.form.style.setProperty('display', wasOpen ? 'block' : 'none', 'important');
      }

      const pendingTrigger = pendingModalTriggers.get(widget);
      if (pendingTrigger) {
        pendingModalTriggers.delete(widget);
        state.open(pendingTrigger);
      }
    };

    const syncReviewSuccess = (widget) => {
      const state = modalState.get(widget);
      if (!state || state.submitted || !state.modal.hasAttribute('open')) return;
      const responseText = [
        ...new Set([
          state.form,
          state.content,
          ...widget.querySelectorAll(
            '.jdgm-form-wrapper, .jdgm-form__message, .jdgm-notification, .jdgm-rev-widg__body'
          ),
        ]),
      ]
        .filter((element) => element && !element.closest('.hbc-review-modal__success'))
        .map((element) => element.textContent.toLowerCase())
        .join(' ');
      const hasSuccessClass = !!widget.querySelector(
        '.jdgm-form__message--success, .jdgm-form--done, .jdgm-notification--success, .jdgm-form-wrapper--done'
      );
      const submitted =
        hasSuccessClass ||
        responseText.includes('review submitted') ||
        responseText.includes('review has been added') ||
        responseText.includes('thank you! please refresh') ||
        responseText.includes('thank you for your review') ||
        responseText.includes('thank you');
      if (submitted) state.showSuccess();
    };

    const enhance = (widget) => {
      const reviewsTarget = document.querySelector('[data-hbc-reviews-target]');
      const appSection = widget.closest('.hbc-app-section');
      if (reviewsTarget && appSection && !reviewsTarget.contains(appSection)) {
        reviewsTarget.querySelector('.hbc-product-tabs__reviews-loading')?.remove();
        appSection.classList.remove('scroll-trigger', 'animate--slide-in');
        appSection.style.transform = 'none';
        reviewsTarget.append(appSection);
      }

      structureOverview(widget);
      setupReviewModal(widget);
      syncReviewSuccess(widget);
      const reviews = widget.querySelector(reviewsSelector);
      if (!reviews) return;

      const cards = [...reviews.querySelectorAll(reviewSelector)];
      structureReviewCards(cards);
      const existingNavigation = widget.querySelector('.hbc-review-carousel__navigation');

      if (cards.length <= 4) {
        reviews.classList.remove('hbc-review-carousel');
        reviews.removeAttribute('role');
        reviews.removeAttribute('aria-label');
        reviews.removeAttribute('tabindex');
        cards.forEach((card) => {
          card.removeAttribute('role');
          card.removeAttribute('aria-label');
        });
        existingNavigation?.remove();
        widget.removeAttribute('data-hbc-review-count');
        return;
      }

      const section = widget.closest('.hbc-app-section');
      const sliderName = section?.dataset.sliderName || 'Slider';
      const sliderOf = section?.dataset.sliderOf || 'of';
      const previousLabel = section?.dataset.sliderPrevious || 'Previous slide';
      const nextLabel = section?.dataset.sliderNext || 'Next slide';
      const signature = `${cards.length}:${cards.map((card) => card.textContent.trim().slice(0, 30)).join('|')}`;

      if (
        widget.dataset.hbcReviewCount === signature &&
        existingNavigation &&
        reviews.classList.contains('hbc-review-carousel')
      )
        return;

      existingNavigation?.remove();
      widget.dataset.hbcReviewCount = signature;
      reviews.classList.add('hbc-review-carousel');
      reviews.setAttribute('role', 'region');
      reviews.setAttribute('aria-label', sliderName);
      reviews.setAttribute('tabindex', '0');

      cards.forEach((card, index) => {
        card.setAttribute('role', 'group');
        card.setAttribute('aria-label', `${index + 1} ${sliderOf} ${cards.length}`);
      });

      const navigation = document.createElement('div');
      navigation.className = 'hbc-review-carousel__navigation';
      navigation.innerHTML = `
        <button class="hbc-review-carousel__button hbc-review-carousel__button--previous" type="button" aria-label="${previousLabel}">${icon(
        'previous'
      )}</button>
        <div class="hbc-review-carousel__dots"></div>
        <button class="hbc-review-carousel__button hbc-review-carousel__button--next" type="button" aria-label="${nextLabel}">${icon(
        'next'
      )}</button>
      `;
      reviews.insertAdjacentElement('afterend', navigation);

      const previous = navigation.querySelector('.hbc-review-carousel__button--previous');
      const next = navigation.querySelector('.hbc-review-carousel__button--next');
      const dots = navigation.querySelector('.hbc-review-carousel__dots');
      let activeIndex = 0;
      let maximumIndex = cards.length - 1;

      const scrollToCard = (index) => {
        activeIndex = Math.max(0, Math.min(index, maximumIndex));
        reviews.scrollTo({ left: cards[activeIndex].offsetLeft - cards[0].offsetLeft, behavior: 'smooth' });
        updateControls();
      };

      const updateControls = () => {
        const cardWidth = cards[0].getBoundingClientRect().width;
        const styles = getComputedStyle(reviews);
        const gap = parseFloat(styles.columnGap) || 0;
        const visibleCards = Math.max(1, Math.round((reviews.clientWidth + gap) / (cardWidth + gap)));
        maximumIndex = Math.max(0, cards.length - visibleCards);
        activeIndex = Math.min(activeIndex, maximumIndex);

        dots.replaceChildren();
        for (let index = 0; index <= maximumIndex; index += 1) {
          const dot = document.createElement('button');
          dot.type = 'button';
          dot.className = 'hbc-review-carousel__dot';
          dot.setAttribute('aria-label', `${sliderName} ${index + 1}`);
          dot.setAttribute('aria-current', index === activeIndex ? 'true' : 'false');
          dot.addEventListener('click', () => scrollToCard(index));
          dots.append(dot);
        }

        previous.disabled = activeIndex === 0;
        next.disabled = activeIndex === maximumIndex;
      };

      let scrollFrame;
      reviews.addEventListener(
        'scroll',
        () => {
          cancelAnimationFrame(scrollFrame);
          scrollFrame = requestAnimationFrame(() => {
            const cardStart = cards[0].offsetLeft;
            const positions = cards
              .slice(0, maximumIndex + 1)
              .map((card) => Math.abs(card.offsetLeft - cardStart - reviews.scrollLeft));
            activeIndex = positions.indexOf(Math.min(...positions));
            [...dots.children].forEach((dot, index) =>
              dot.setAttribute('aria-current', index === activeIndex ? 'true' : 'false')
            );
            previous.disabled = activeIndex === 0;
            next.disabled = activeIndex === maximumIndex;
          });
        },
        { passive: true }
      );

      previous.addEventListener('click', () => scrollToCard(activeIndex - 1));
      next.addEventListener('click', () => scrollToCard(activeIndex + 1));
      new ResizeObserver(updateControls).observe(reviews);
      updateControls();
    };

    const enhanceAll = () => document.querySelectorAll(widgetSelector).forEach(enhance);
    let mutationFrame;
    const observer = new MutationObserver((mutations) => {
      let isRelevant = false;
      for (let i = 0; i < mutations.length; i += 1) {
        const mutation = mutations[i];
        const target = mutation.target;
        if (target && target.nodeType === 1) {
          if (
            target.id === 'judgeme_product_reviews' ||
            target.closest?.(widgetSelector) ||
            target.closest?.('.hbc-review-modal') ||
            target.closest?.('[data-hbc-reviews-target]') ||
            target.classList?.contains('jdgm-widget') ||
            target.classList?.contains('hbc-app-section')
          ) {
            isRelevant = true;
            break;
          }
        }
        for (let j = 0; j < mutation.addedNodes.length; j += 1) {
          const node = mutation.addedNodes[j];
          if (node.nodeType === 1) {
            if (
              node.id === 'judgeme_product_reviews' ||
              node.classList?.contains('jdgm-widget') ||
              node.querySelector?.(widgetSelector) ||
              node.closest?.(widgetSelector)
            ) {
              isRelevant = true;
              break;
            }
          }
        }
        if (isRelevant) break;
        for (let k = 0; k < mutation.removedNodes.length; k += 1) {
          const node = mutation.removedNodes[k];
          if (node.nodeType === 1) {
            if (
              node.id === 'judgeme_product_reviews' ||
              node.classList?.contains('jdgm-widget') ||
              node.querySelector?.(widgetSelector)
            ) {
              isRelevant = true;
              break;
            }
          }
        }
        if (isRelevant) break;
      }

      if (!isRelevant) return;

      document.querySelectorAll(widgetSelector).forEach(syncReviewSuccess);
      cancelAnimationFrame(mutationFrame);
      mutationFrame = requestAnimationFrame(enhanceAll);
    });

    const start = () => {
      document.addEventListener(
        'click',
        (event) => {
          const trigger = event.target.closest(writeReviewSelector);
          const widget = trigger?.closest(widgetSelector);
          if (!widget) return;

          const state = modalState.get(widget);
          if (state?.synchronizing) return;
          if (state) {
            event.preventDefault();
            event.stopImmediatePropagation();
            state.open(trigger);
            return;
          }

          pendingModalTriggers.set(widget, trigger);
        },
        true
      );
      enhanceAll();
      observer.observe(document.body, {
        attributes: true,
        characterData: true,
        childList: true,
        subtree: true,
        attributeFilter: ['class', 'hidden', 'style'],
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', start, { once: true });
    } else {
      start();
    }
  })();

  /* ==========================================================================
     Judge.me Cards Carousel — Center Zoom & Dots Synchronization Helper
     Scoped ONLY to block AZE5jdlV6YnRuR2oyT__judge_me_reviews_cards_carousel_TUB3bm
     ========================================================================== */
  (() => {
    const targetBlockId = 'AZE5jdlV6YnRuR2oyT__judge_me_reviews_cards_carousel_TUB3bm';

    // Robust target block resolution
    const getTargetBlock = () => {
      return (
        document.querySelector(`[data-jdgm-block-id*="judge_me_reviews_cards_carousel_TUB3bm"]`) ||
        document.querySelector(`[id*="judge_me_reviews_cards_carousel_TUB3bm"]`) ||
        document.querySelector('.hbc-app-section .jdgm-cards-carousel')?.closest('.shopify-app-block') ||
        document.querySelector('.hbc-app-section:has(.jdgm-cards-carousel)') ||
        document.querySelector('.jdgm-cards-carousel')?.closest('.shopify-app-block') ||
        document.querySelector('.jdgm-cards-carousel') ||
        document.querySelector(`[data-jdgm-block-id="${targetBlockId}"]`)
      );
    };

    const isTargetWrapper = (wrapper) => {
      if (!wrapper) return false;
      return !!(
        wrapper.closest(`[data-jdgm-block-id*="judge_me_reviews_cards_carousel_TUB3bm"]`) ||
        wrapper.closest(`[id*="judge_me_reviews_cards_carousel_TUB3bm"]`) ||
        wrapper.closest('.hbc-app-section') ||
        wrapper.closest('.jdgm-cards-carousel')
      );
    };

    // 1. Synchronously intercept and monkey-patch Judge.me's calculateAndApplyTransform
    let _carouselCenter = window.jdgmCarouselCenter;
    const wrapCarouselCenter = (obj) => {
      if (!obj || obj._hbcPatched) return obj;
      obj._hbcPatched = true;
      const originalCalc = obj.calculateAndApplyTransform;
      if (typeof originalCalc === 'function') {
        obj.calculateAndApplyTransform = function (container, activeCard, wrapper, getTarget, getCard, clampFn) {
          if (isTargetWrapper(wrapper)) {
            getTarget = (wRect) => wRect.left + wRect.width / 2;
            getCard = (cRect) => cRect.left + cRect.width / 2;
          }
          return originalCalc.call(this, container, activeCard, wrapper, getTarget, getCard, clampFn);
        };
      }
      return obj;
    };

    if (_carouselCenter) {
      wrapCarouselCenter(_carouselCenter);
    }
    try {
      Object.defineProperty(window, 'jdgmCarouselCenter', {
        configurable: true,
        enumerable: true,
        get() {
          return _carouselCenter;
        },
        set(val) {
          _carouselCenter = wrapCarouselCenter(val);
        },
      });
    } catch (e) {}

    const patchJudgeMeCenter = () => {
      if (window.jdgmCarouselCenter) {
        wrapCarouselCenter(window.jdgmCarouselCenter);
      }
    };

    // 2. Center positioning on initial load / layout mutations / resize
    const centerCarousel = (isInitial = false) => {
      const block = getTargetBlock();
      if (!block) return;
      if (isInitial && block._hbcUserInteracted) return;

      const container =
        block.querySelector('.jdgm-videos-container') ||
        document.querySelector('.jdgm-cards-carousel .jdgm-videos-container');
      const wrapper =
        block.querySelector('.jdgm-cards-wrapper') ||
        document.querySelector('.jdgm-cards-carousel .jdgm-cards-wrapper');
      if (!container || !wrapper) return;

      const activeCard =
        container.querySelector('.jdgm-media-card.active') ||
        container.querySelector('.jdgm-media-card:not(.jdgm-clone-before):not(.jdgm-clone-after)') ||
        container.querySelector('.jdgm-media-card');
      if (!activeCard) return;

      const wRect = wrapper.getBoundingClientRect();
      const cRect = activeCard.getBoundingClientRect();
      if (wRect.width === 0 || cRect.width === 0) return;

      const targetX = wRect.left + wRect.width / 2 - (cRect.left + cRect.width / 2);
      if (Math.abs(targetX) > 1.5) {
        let currentX = 0;
        const transform = window.getComputedStyle(container).transform;
        if (transform && transform !== 'none') {
          try {
            currentX = new DOMMatrixReadOnly(transform).m41;
          } catch (e) {
            const m = transform.match(/matrix\([^,]+,[^,]+,[^,]+,[^,]+,([^,]+),[^,]+\)/);
            if (m) currentX = parseFloat(m[1]);
          }
        }
        block._hbcIsCentering = true;
        container.style.setProperty('transition', 'none', 'important');
        container.style.transform = `translateX(${currentX + targetX}px)`;
        container.offsetHeight;
        requestAnimationFrame(() => {
          container.style.removeProperty('transition');
          block._hbcIsCentering = false;
        });
      }
    };

    // 3. Build and synchronize pagination dots
    const syncDots = () => {
      const block = getTargetBlock();
      if (!block) return;

      const container =
        block.querySelector('.jdgm-videos-container') ||
        document.querySelector('.jdgm-cards-carousel .jdgm-videos-container');
      if (!container) return;

      const cards = Array.from(container.querySelectorAll('.jdgm-media-card'));
      const realCards = cards.filter(
        (c) => !c.classList.contains('jdgm-clone-before') && !c.classList.contains('jdgm-clone-after')
      );
      if (realCards.length === 0) return;

      let dotsWrap = block.querySelector('.hbc-jdgm-dots');
      if (!dotsWrap) {
        dotsWrap = document.createElement('div');
        dotsWrap.className = 'hbc-jdgm-dots';
        dotsWrap.setAttribute('role', 'tablist');
        dotsWrap.setAttribute('aria-label', 'Review slides');

        realCards.forEach((card, index) => {
          const dot = document.createElement('button');
          dot.type = 'button';
          dot.className = 'hbc-jdgm-dot';
          dot.setAttribute('role', 'tab');
          dot.setAttribute('aria-label', `Go to slide ${index + 1}`);
          dot.addEventListener('click', (e) => {
            e.preventDefault();
            block._hbcUserInteracted = true;
            if (window.jdgmCarouselNav && window.jdgmCarouselNav.revealCard) {
              const bId = card.closest('[data-jdgm-block-id]')?.getAttribute('data-jdgm-block-id') || targetBlockId;
              window.jdgmCarouselNav.revealCard(bId, card);
            }
          });
          dotsWrap.appendChild(dot);
        });

        block.appendChild(dotsWrap);
      }

      // Update active dot
      const activeCard = container.querySelector('.jdgm-media-card.active');
      if (activeCard && dotsWrap) {
        const activeReviewId = activeCard.getAttribute('data-review-id');
        const dots = Array.from(dotsWrap.querySelectorAll('.hbc-jdgm-dot'));
        realCards.forEach((card, index) => {
          const isCurrent =
            (activeReviewId && card.getAttribute('data-review-id') === activeReviewId) || card === activeCard;
          if (dots[index]) {
            if (isCurrent) {
              dots[index].setAttribute('aria-current', 'true');
            } else {
              dots[index].removeAttribute('aria-current');
            }
          }
        });
      }
    };

    // 4. Bind card-click to smoothly navigate and center
    const bindCardClicks = () => {
      const block = getTargetBlock();
      if (!block) return;
      const cards = block.querySelectorAll('.jdgm-media-card');
      cards.forEach((card) => {
        if (!card._hbcClickBound) {
          card._hbcClickBound = true;
          card.addEventListener('click', (e) => {
            if (e.target.closest('a, button, input')) return;
            if (!card.classList.contains('active') && window.jdgmCarouselNav && window.jdgmCarouselNav.revealCard) {
              e.preventDefault();
              block._hbcUserInteracted = true;
              const bId = card.closest('[data-jdgm-block-id]')?.getAttribute('data-jdgm-block-id') || targetBlockId;
              window.jdgmCarouselNav.revealCard(bId, card);
            }
          });
        }
      });
    };

    // 5. Expose Review Titles from Judge.me review data
    let _buildMediaCards = window.jdgmBuildMediaCards;
    const exposeReviewTitles = () => {
      const block = getTargetBlock();
      if (!block) return;
      const reviewsData =
        window._hbcJdgmReviews || window.jdgmCarouselMode?.[targetBlockId]?.reviews || window.jdgm?.data?.reviews;
      const cards = block.querySelectorAll('.jdgm-media-card');
      cards.forEach((card) => {
        if (card.querySelector('.jdgm-rev__title')) return;
        const reviewId = card.getAttribute('data-review-id');
        const cardIndex = parseInt(card.getAttribute('data-card-index'), 10);
        let title = '';
        if (reviewsData && Array.isArray(reviewsData)) {
          const rev =
            (reviewId && reviewsData.find((r) => r.uuid === reviewId || String(r.id) === reviewId)) ||
            reviewsData[cardIndex];
          if (rev && rev.title) title = rev.title.trim();
        }
        if (title) {
          const titleEl = document.createElement('div');
          titleEl.className = 'jdgm-rev__title';
          const parser = new DOMParser();
          const decoded = parser.parseFromString(title, 'text/html').body.textContent || title;
          titleEl.textContent = decoded;
          const textEl = card.querySelector('.jdgm-text');
          if (textEl) {
            textEl.insertAdjacentElement('beforebegin', titleEl);
          } else {
            card.appendChild(titleEl);
          }
        }
      });
    };

    try {
      Object.defineProperty(window, 'jdgmBuildMediaCards', {
        configurable: true,
        enumerable: true,
        get() {
          return _buildMediaCards;
        },
        set(fn) {
          _buildMediaCards = function (t, e, a) {
            if (a && a.reviews) window._hbcJdgmReviews = a.reviews;
            const res = fn.apply(this, arguments);
            try {
              exposeReviewTitles();
            } catch (err) {}
            return res;
          };
        },
      });
      if (_buildMediaCards) window.jdgmBuildMediaCards = _buildMediaCards;
    } catch (e) {}

    // 6. Watch for Judge.me initialization and slide transitions
    const init = () => {
      patchJudgeMeCenter();

      const block = getTargetBlock();
      if (!block) return;

      // Detect ONLY actual navigation controls (arrows, dots, swipe gestures)
      if (!block._hbcNavInteractionBound) {
        block._hbcNavInteractionBound = true;
        block.addEventListener(
          'click',
          (e) => {
            if (e.target.closest('.jdgm-arrow, .hbc-jdgm-dot, .hbc-review-carousel__dot')) {
              block._hbcUserInteracted = true;
            }
          },
          { capture: true, passive: true }
        );

        let touchStartX = 0;
        let touchStartY = 0;
        block.addEventListener(
          'touchstart',
          (e) => {
            if (e.touches && e.touches.length > 0) {
              touchStartX = e.touches[0].clientX;
              touchStartY = e.touches[0].clientY;
            }
          },
          { capture: true, passive: true }
        );

        block.addEventListener(
          'touchmove',
          (e) => {
            if (e.touches && e.touches.length > 0) {
              const deltaX = Math.abs(e.touches[0].clientX - touchStartX);
              const deltaY = Math.abs(e.touches[0].clientY - touchStartY);
              if (deltaX > 10 && deltaX > deltaY) {
                block._hbcUserInteracted = true;
              }
            }
          },
          { capture: true, passive: true }
        );
      }

      bindCardClicks();
      exposeReviewTitles();
      syncDots();

      const container =
        block.querySelector('.jdgm-videos-container') ||
        document.querySelector('.jdgm-cards-carousel .jdgm-videos-container');
      if (container) {
        if (!block._hbcUserInteracted) {
          centerCarousel(true);
        }

        if (!container._hbcObserved) {
          container._hbcObserved = true;
          const observer = new MutationObserver(() => {
            if (block._hbcIsCentering) return;
            patchJudgeMeCenter();
            bindCardClicks();
            exposeReviewTitles();
            syncDots();
            if (!block._hbcUserInteracted) {
              centerCarousel(true);
            }
          });
          observer.observe(container, {
            attributes: true,
            attributeFilter: ['class', 'style'],
            childList: true,
            subtree: true,
          });
          container.addEventListener('transitionend', () => {
            syncDots();
          });
        }
      }
    };

    const startWatcher = () => {
      init();
      const section = document.querySelector('.hbc-app-section') || document.body;
      if (section) {
        const sectionObs = new MutationObserver(() => {
          init();
          const b = getTargetBlock();
          if (b && b._hbcUserInteracted) {
            sectionObs.disconnect();
          }
        });
        sectionObs.observe(section, { childList: true, subtree: true });
      }
    };

    if (document.readyState === 'loading') {
      document.addEventListener(
        'DOMContentLoaded',
        () => {
          startWatcher();
          setTimeout(init, 300);
          setTimeout(init, 800);
          setTimeout(init, 1500);
        },
        { once: true }
      );
    } else {
      startWatcher();
      setTimeout(init, 300);
      setTimeout(init, 800);
      setTimeout(init, 1500);
    }

    window.addEventListener(
      'load',
      () => {
        init();
        setTimeout(init, 150);
        setTimeout(init, 500);
      },
      { once: true }
    );

    window.addEventListener(
      'resize',
      () => {
        centerCarousel();
      },
      { passive: true }
    );
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["baby-sleep-essentials"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('baby-sleep-tabs')) {
    customElements.define(
      'baby-sleep-tabs',
      class extends HTMLElement {
        connectedCallback() {
          this.init();
        }

        disconnectedCallback() {
          this.destroy();
        }

        destroy() {
          this.stopAutoplay();
          if (this.boundVisibilityChange) {
            document.removeEventListener('visibilitychange', this.boundVisibilityChange);
            this.boundVisibilityChange = null;
          }
          if (this.boundResize) {
            window.removeEventListener('resize', this.boundResize);
            this.boundResize = null;
          }
          if (this.boundMotionChange && this.motionQuery) {
            this.motionQuery.removeEventListener('change', this.boundMotionChange);
            this.boundMotionChange = null;
            this.motionQuery = null;
          }
          this.initialized = false;
        }

        init() {
          this.destroy();
          this.tabs = [...this.querySelectorAll('[role="tab"]')];
          this.panels = [...this.querySelectorAll('[role="tabpanel"]')];
          this.viewAll = this.querySelector('[data-bse-view-all]');
          this.autoplayEnabled = this.dataset.autoplay !== 'false';
          const intervalSec = parseFloat(this.dataset.autoplayInterval);
          this.autoplayInterval = (!isNaN(intervalSec) && intervalSec >= 4 && intervalSec <= 5)
            ? intervalSec * 1000
            : 4500;
          this.timer = null;
          this.isPaused = false;

          this.sliders = [...this.querySelectorAll('.bse__panel')]
            .map((panel) => {
              const track = panel.querySelector('.bse__grid');
              const dots = [...panel.querySelectorAll('[data-bse-slider-page]')];
              if (!track || !dots.length) return null;
              let rafId = null;
              const update = () => {
                if (!track.clientWidth) return;
                const firstItem = track.querySelector('.bse__grid-item');
                if (!firstItem) return;
                const step = firstItem.offsetWidth + (parseFloat(getComputedStyle(track).columnGap || 0) || 0);
                if (step <= 0) return;
                const maxIndex = Math.max(0, Math.round((track.scrollWidth - track.clientWidth) / step));
                const activeIndex = Math.min(maxIndex, Math.max(0, Math.round(track.scrollLeft / step)));
                dots.forEach((dot, index) => {
                  dot.hidden = index > maxIndex;
                  if (index === activeIndex) dot.setAttribute('aria-current', 'true');
                  else dot.removeAttribute('aria-current');
                });
              };
              const scheduleUpdate = () => {
                if (rafId) cancelAnimationFrame(rafId);
                rafId = requestAnimationFrame(update);
              };
              dots.forEach((dot) => {
                dot.addEventListener('click', () => {
                  const item = track.querySelectorAll('.bse__grid-item')[Number(dot.dataset.bseSliderPage)];
                  if (item) {
                    track.scrollTo({
                      left: item.offsetLeft - track.offsetLeft,
                      behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
                    });
                    this.restartAutoplay();
                  }
                });
              });
              track.addEventListener('scroll', scheduleUpdate, { passive: true });
              window.addEventListener('resize', scheduleUpdate, { passive: true });
              scheduleUpdate();
              return { track, update: scheduleUpdate };
            })
            .filter(Boolean);

          this.tabs.forEach((tab, index) => {
            tab.addEventListener('click', () => {
              this.select(tab);
              this.restartAutoplay();
            });
            tab.addEventListener('keydown', (event) => this.onKeydown(event, index));
          });

          if (this.viewAll) {
            this.viewAll.addEventListener('focus', () => this.revealTab(this.viewAll));
            this.viewAll.addEventListener('click', () => this.revealTab(this.viewAll));
          }

          if (Shopify.designMode) {
            this.addEventListener('shopify:block:select', (event) => {
              const tab = this.querySelector(`#BabySleepTab-${event.detail.blockId}`);
              if (tab) this.select(tab);
            });
            document.addEventListener('shopify:section:load', (event) => {
              if (event.target === this.closest('.shopify-section') || event.target.contains(this)) {
                this.init();
              }
            });
          }

          const activeTab = this.tabs.find((tab) => tab.getAttribute('aria-selected') === 'true') || this.tabs[0];
          if (activeTab) {
            this.select(activeTab);
            requestAnimationFrame(() => {
              this.revealTab(activeTab, false);
            });
          }

          this.boundResize = () => {
            const currentTab = this.tabs.find((tab) => tab.getAttribute('aria-selected') === 'true') || this.tabs[0];
            if (currentTab) this.revealTab(currentTab, false);
          };
          window.addEventListener('resize', this.boundResize, { passive: true });

          this.setupAutoplay();
          this.initialized = true;
        }

        setupAutoplay() {
          if (!this.autoplayEnabled || this.tabs.length <= 1) return;

          this.addEventListener('mouseenter', () => {
            this.isPaused = true;
          });
          this.addEventListener('mouseleave', () => {
            this.isPaused = false;
            this.restartAutoplay();
          });
          this.addEventListener('focusin', () => {
            this.isPaused = true;
          });
          this.addEventListener('focusout', (e) => {
            if (!this.contains(e.relatedTarget)) {
              this.isPaused = false;
              this.restartAutoplay();
            }
          });
          this.addEventListener(
            'touchstart',
            () => {
              this.isPaused = true;
            },
            { passive: true }
          );
          this.addEventListener(
            'touchend',
            () => {
              setTimeout(() => {
                this.isPaused = false;
                this.restartAutoplay();
              }, 2000);
            },
            { passive: true }
          );

          this.boundVisibilityChange = () => {
            if (document.hidden) {
              this.stopAutoplay();
            } else {
              this.startAutoplay();
            }
          };
          document.addEventListener('visibilitychange', this.boundVisibilityChange);

          this.motionQuery = matchMedia('(prefers-reduced-motion: reduce)');
          this.boundMotionChange = (e) => {
            if (e.matches) {
              this.stopAutoplay();
            } else {
              this.startAutoplay();
            }
          };
          if (this.motionQuery.addEventListener) {
            this.motionQuery.addEventListener('change', this.boundMotionChange);
          }

          this.startAutoplay();
        }

        startAutoplay() {
          this.stopAutoplay();
          if (!this.autoplayEnabled || this.tabs.length <= 1) return;
          if (matchMedia('(prefers-reduced-motion: reduce)').matches) return;

          this.timer = setInterval(() => {
            if (this.isPaused) return;
            this.nextStep();
          }, this.autoplayInterval);
        }

        stopAutoplay() {
          if (this.timer) {
            clearInterval(this.timer);
            this.timer = null;
          }
        }

        restartAutoplay() {
          this.stopAutoplay();
          this.startAutoplay();
        }

        nextStep() {
          if (this.tabs.length <= 1) return;
          if (matchMedia('(prefers-reduced-motion: reduce)').matches) return;

          const currentIndex = this.tabs.findIndex((tab) => tab.getAttribute('aria-selected') === 'true');
          const nextIndex = (currentIndex + 1) % this.tabs.length;
          const nextTab = this.tabs[nextIndex];
          if (nextTab) {
            this.select(nextTab, true);
          }
        }

        select(selectedTab, fromAutoplay = false) {
          if (!selectedTab) return;
          this.tabs.forEach((tab) => {
            const selected = tab === selectedTab;
            tab.setAttribute('aria-selected', String(selected));
            tab.tabIndex = selected ? 0 : -1;
          });
          this.panels.forEach((panel) => {
            panel.hidden = panel.id !== selectedTab.getAttribute('aria-controls');
          });
          const activePanel = this.querySelector(`#${selectedTab.getAttribute('aria-controls')}`);
          if (activePanel) {
            const track = activePanel.querySelector('.bse__grid');
            if (track && fromAutoplay) {
              track.scrollLeft = 0;
            }
          }
          const activeSlider = this.sliders.find((slider) => slider.track.closest('.bse__panel') === activePanel);
          if (activeSlider) activeSlider.update();
          this.revealTab(selectedTab);

          if (this.viewAll) {
            const hasCustomLink = this.dataset.hasCustomViewAll === 'true';
            if (!hasCustomLink && selectedTab && selectedTab.dataset.viewAllUrl) {
              this.viewAll.href = selectedTab.dataset.viewAllUrl;
            } else if (hasCustomLink && this.dataset.defaultViewAll) {
              this.viewAll.href = this.dataset.defaultViewAll;
            }
          }
        }

        revealTab(selectedTab, smooth = true) {
          if (!selectedTab || !matchMedia('(max-width: 749px)').matches) return;
          const scroller = selectedTab.closest('.bse__tabs-wrap') || selectedTab.closest('.bse__tabs');
          if (!scroller) return;

          const scrollerBox = scroller.getBoundingClientRect();
          const tabBox = selectedTab.getBoundingClientRect();
          if (scrollerBox.width <= 0) {
            requestAnimationFrame(() => this.revealTab(selectedTab, smooth));
            return;
          }

          const tabCenter = tabBox.left - scrollerBox.left + tabBox.width / 2;
          const scrollerCenter = scrollerBox.width / 2;
          const delta = tabCenter - scrollerCenter;

          const maxScroll = Math.max(0, scroller.scrollWidth - scroller.clientWidth);
          const targetLeft = Math.max(0, Math.min(scroller.scrollLeft + delta, maxScroll));

          const prefersReducedMotion = matchMedia('(prefers-reduced-motion: reduce)').matches;
          const behavior = smooth && !prefersReducedMotion ? 'smooth' : 'auto';

          scroller.scrollTo({
            left: targetLeft,
            behavior: behavior,
          });
        }

        onKeydown(event, index) {
          let nextIndex;
          if (event.key === 'ArrowRight') nextIndex = (index + 1) % this.tabs.length;
          if (event.key === 'ArrowLeft') nextIndex = (index - 1 + this.tabs.length) % this.tabs.length;
          if (event.key === 'Home') nextIndex = 0;
          if (event.key === 'End') nextIndex = this.tabs.length - 1;
          if (nextIndex === undefined) return;
          event.preventDefault();
          this.select(this.tabs[nextIndex]);
          this.tabs[nextIndex].focus();
          this.restartAutoplay();
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 1199px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, { passive: true });

      this.createObserver();
    }

    setHeaderHeight() {
      requestAnimationFrame(() => {
        if (this.header) {
          document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
        }
      });
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal?.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["reference-faq"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('reference-faq')) {
    customElements.define(
      'reference-faq',
      class ReferenceFaq extends HTMLElement {
        connectedCallback() {
          if (this.dataset.singleOpen !== 'true') return;

          const openItems = this.querySelectorAll('.reference-faq__details[open]');
          openItems.forEach((item, index) => {
            if (index > 0) item.removeAttribute('open');
          });

          this.addEventListener('toggle', (event) => {
            const activeItem = event.target;
            if (!activeItem.matches('.reference-faq__details') || !activeItem.open) return;

            this.querySelectorAll('.reference-faq__details[open]').forEach((item) => {
              if (item !== activeItem) item.removeAttribute('open');
            });
          }, true);
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["search-drawer"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('search-drawer')) {
    class SearchDrawer extends HTMLElement {
      connectedCallback() {
        this.dialog = this.querySelector('dialog');
        this.search = this.querySelector('predictive-search, search-form');
        this.input = this.querySelector('input[type="search"]');
        this.resetButton = this.querySelector('[type="reset"]');
        this.onDocumentClick = this.handleDocumentClick.bind(this);
        this.onInput = this.handleInput.bind(this);
        this.onDialogClick = this.handleDialogClick.bind(this);
        this.onClose = this.handleClose.bind(this);
        this.onKeyDown = this.handleKeyDown.bind(this);

        document.addEventListener('click', this.onDocumentClick);
        document.addEventListener('keydown', this.onKeyDown);
        if (this.input) {
          this.input.addEventListener('input', this.onInput);
          this.input.form?.addEventListener('reset', this.onInput);
        }
        if (this.dialog) {
          this.dialog.addEventListener('click', this.onDialogClick);
          this.dialog.addEventListener('close', this.onClose);
        }
      }

      disconnectedCallback() {
        document.removeEventListener('click', this.onDocumentClick);
        document.removeEventListener('keydown', this.onKeyDown);
        if (this.input) {
          this.input.removeEventListener('input', this.onInput);
          this.input.form?.removeEventListener('reset', this.onInput);
        }
        if (this.dialog) {
          this.dialog.removeEventListener('click', this.onDialogClick);
          this.dialog.removeEventListener('close', this.onClose);
        }
      }

      handleDocumentClick(event) {
        const opener = event.target.closest('[data-search-drawer-open]');
        const closer = event.target.closest('[data-search-drawer-close]');

        if (opener) {
          this.activeTrigger = opener;
          if (this.dialog && !this.dialog.open) {
            this.dialog.showModal();
            document.body.classList.add('overflow-hidden');
          }
          requestAnimationFrame(() => this.input?.focus());
        }

        if (closer) {
          event.preventDefault();
          this.closeDrawer();
        }
      }

      handleKeyDown(event) {
        if (event.key === 'Escape' && this.dialog?.open) {
          this.closeDrawer();
        }
      }

      handleInput() {
        requestAnimationFrame(() => {
          const hasQuery = this.input.value.trim().length > 0;
          this.search?.classList.toggle('has-query', hasQuery);
          this.resetButton?.classList.toggle('hidden', !hasQuery);
        });
      }

      handleDialogClick(event) {
        if (event.target === this.dialog) {
          this.closeDrawer();
        }
      }

      closeDrawer() {
        if (this.dialog?.open) {
          this.dialog.close();
        } else {
          this.handleClose();
        }
      }

      handleClose() {
        document.body.classList.remove('overflow-hidden');
        if (this.input?.form) this.input.form.reset();
        this.search?.classList.remove('has-query');
        this.resetButton?.classList.add('hidden');
        if (typeof this.search?.close === 'function') this.search.close(true);
        if (this.activeTrigger && typeof this.activeTrigger.focus === 'function') {
          this.activeTrigger.focus();
        }
      }
    }

    customElements.define('search-drawer', SearchDrawer);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shop-the-look"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('shop-the-look')) {
    customElements.define(
      'shop-the-look',
      class ShopTheLook extends HTMLElement {
        connectedCallback() {
          this.init();
        }

        disconnectedCallback() {
          if (this.addAllBtn && this.boundAddAll) {
            this.addAllBtn.removeEventListener('click', this.boundAddAll);
          }
        }

        init() {
          this.cards = Array.from(this.querySelectorAll('.shop-the-look__card'));
          this.hotspots = Array.from(this.querySelectorAll('.shop-the-look__hotspot-wrap'));
          this.triggers = Array.from(this.querySelectorAll('[data-trigger-index]'));
          this.addAllBtn = this.querySelector('[data-shop-the-look-add-all]');

          this.triggers.forEach((trigger) => {
            const index = Number(trigger.dataset.triggerIndex);
            trigger.addEventListener('click', (e) => {
              e.stopPropagation();
              this.setActive(index);
              this.scrollToCardOnMobile(index);
            });
          });

          this.hotspots.forEach((hotspot) => {
            const index = Number(hotspot.dataset.hotspotIndex);
            hotspot.addEventListener('mouseenter', () => this.setActive(index));
            hotspot.addEventListener('click', () => {
              this.setActive(index);
              this.scrollToCardOnMobile(index);
            });
          });

          this.cards.forEach((card) => {
            const index = Number(card.dataset.cardIndex);
            card.addEventListener('mouseenter', () => this.setActive(index));
            card.addEventListener('click', (e) => {
              if (!e.target.closest('button') && !e.target.closest('a')) {
                this.setActive(index);
              }
            });
          });

          if (this.addAllBtn) {
            if (this.boundAddAll) {
              this.addAllBtn.removeEventListener('click', this.boundAddAll);
            }
            this.boundAddAll = this.onAddAllClick.bind(this);
            this.addAllBtn.addEventListener('click', this.boundAddAll);
          }

          if (Shopify.designMode) {
            this.addEventListener('shopify:block:select', (event) => {
              const blockId = event.detail.blockId;
              const target = this.querySelector(`[data-block-id="${blockId}"]`);
              if (target) {
                const index = Number(target.dataset.hotspotIndex ?? target.dataset.cardIndex);
                if (!isNaN(index)) {
                  this.setActive(index);
                  this.scrollToCardOnMobile(index);
                }
              }
            });

            document.addEventListener('shopify:section:load', (event) => {
              if (event.target === this.closest('.shopify-section') || event.target.contains(this)) {
                this.init();
              }
            });
          }
        }

        scrollToCardOnMobile(index) {
          const isMobile = window.innerWidth <= 860 || window.matchMedia('(max-width: 860px)').matches;
          if (!isMobile) return;

          const targetCard =
            this.cards[index] || this.querySelector(`.shop-the-look__card[data-card-index="${index}"]`);
          if (!targetCard) return;

          let headerOffset = 0;
          const stickyHeader = document.querySelector('sticky-header, .header-wrapper, .section-header');
          if (stickyHeader) {
            const rect = stickyHeader.getBoundingClientRect();
            if (rect.height > 0) {
              headerOffset = rect.height;
            }
          }

          const cardRect = targetCard.getBoundingClientRect();
          const targetY = window.pageYOffset + cardRect.top - headerOffset - 16;

          window.scrollTo({
            top: Math.max(0, targetY),
            behavior: 'smooth',
          });
        }

        setActive(index) {
          if (isNaN(index) || index < 0) return;

          this.cards.forEach((card, i) => {
            const isActive = i === index;
            card.classList.toggle('is-active', isActive);
          });

          this.hotspots.forEach((hotspot, i) => {
            const isActive = i === index;
            hotspot.classList.toggle('is-active', isActive);
          });

          this.triggers.forEach((trigger, i) => {
            const isActive = i === index;
            trigger.setAttribute('aria-pressed', String(isActive));
          });
        }

        async onAddAllClick(e) {
          e.preventDefault();
          if (this.addAllBtn.getAttribute('aria-disabled') === 'true') return;

          const availableCards = this.cards.filter((card) => {
            const available = card.dataset.available === 'true';
            const variantId = card.dataset.variantId;
            return available && variantId;
          });

          if (availableCards.length === 0) return;

          const spinner = this.addAllBtn.querySelector('.loading__spinner');
          const btnText = this.addAllBtn.querySelector('.shop-the-look__btn-add-all-text');

          this.addAllBtn.setAttribute('aria-disabled', 'true');
          if (spinner) spinner.classList.remove('hidden');
          if (btnText) btnText.style.opacity = '0';

          // Prevent duplicate additions by deduplicating variant IDs
          const seenVariantIds = new Set();
          const items = [];

          availableCards.forEach((card) => {
            const variantId = Number(card.dataset.variantId);
            if (variantId && !seenVariantIds.has(variantId)) {
              seenVariantIds.add(variantId);
              items.push({
                id: variantId,
                quantity: 1,
              });
            }
          });

          if (items.length === 0) {
            this.addAllBtn.removeAttribute('aria-disabled');
            if (spinner) spinner.classList.add('hidden');
            if (btnText) btnText.style.opacity = '1';
            return;
          }

          const cartDrawer = document.querySelector('cart-drawer') || document.querySelector('cart-notification');

          const bodyData = {
            items: items,
          };

          if (cartDrawer && typeof cartDrawer.getSectionsToRender === 'function') {
            bodyData.sections = cartDrawer.getSectionsToRender().map((s) => s.id);
            bodyData.sections_url = window.location.pathname;
          }

          try {
            const response = await fetch(`${window.routes?.cart_add_url || '/cart/add.js'}`, {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
                'X-Requested-With': 'XMLHttpRequest',
              },
              body: JSON.stringify(bodyData),
            });

            let data = await response.json();

            // If batch addition failed (e.g. 422 for partial out of stock), try adding available items sequentially
            if (data.status) {
              let addedAny = false;
              for (const item of items) {
                try {
                  const singleRes = await fetch(`${window.routes?.cart_add_url || '/cart/add.js'}`, {
                    method: 'POST',
                    headers: {
                      'Content-Type': 'application/json',
                      Accept: 'application/json',
                      'X-Requested-With': 'XMLHttpRequest',
                    },
                    body: JSON.stringify({
                      id: item.id,
                      quantity: item.quantity,
                      sections: cartDrawer?.getSectionsToRender ? cartDrawer.getSectionsToRender().map((s) => s.id) : undefined,
                      sections_url: window.location.pathname,
                    }),
                  });
                  const singleData = await singleRes.json();
                  if (!singleData.status) {
                    addedAny = true;
                    data = singleData;
                  }
                } catch (_) {}
              }

              if (!addedAny) {
                console.error('Error adding items to cart:', data.description || data.message);
                return;
              }
            }

            if (window.publish && window.PUB_SUB_EVENTS) {
              window.publish(window.PUB_SUB_EVENTS.cartUpdate, {
                source: 'shop-the-look',
                cartData: data,
              });
            }

            if (cartDrawer) {
              if (data.sections && typeof cartDrawer.renderContents === 'function') {
                cartDrawer.renderContents(data);
              } else if (typeof cartDrawer.open === 'function') {
                fetch(`${window.routes?.cart_url || '/cart'}?section_id=cart-drawer`)
                  .then((r) => r.text())
                  .then((html) => {
                    const parsedDOM = new DOMParser().parseFromString(html, 'text/html');
                    const drawerInner = document.querySelector('#CartDrawer');
                    const newDrawerInner = parsedDOM.querySelector('#CartDrawer');
                    if (drawerInner && newDrawerInner) {
                      drawerInner.innerHTML = newDrawerInner.innerHTML;
                    }
                    cartDrawer.open();
                  })
                  .catch(() => {
                    cartDrawer.open();
                  });
              }
            } else {
              window.location = window.routes?.cart_url || '/cart';
            }
          } catch (err) {
            console.error('Add all to cart failed:', err);
          } finally {
            this.addAllBtn.removeAttribute('aria-disabled');
            if (spinner) spinner.classList.add('hidden');
            if (btnText) btnText.style.opacity = '1';
          }
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["trust-usp-bar"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('trust-usp-slider')) {
    class TrustUspSlider extends HTMLElement {
      connectedCallback() {
        this.list = this.querySelector('.trust-usp-bar__list');
        this.dotsContainer = this.querySelector('.trust-usp-bar__dots');
        this.dots = Array.from(this.querySelectorAll('[data-trust-usp-dot]'));
        this.mobileMedia = window.matchMedia('(max-width: 749px)');
        this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.autoplaySpeed = Number(this.dataset.autoplaySpeed) || 4000;
        this.handleBreakpoint = this.setup.bind(this);
        this.handleScrollEnd = this.onScrollEnd.bind(this);
        this.handleVisibility = this.onVisibilityChange.bind(this);
        this.handleBlockSelect = this.onBlockSelect.bind(this);
        this.handleBlockDeselect = this.onBlockDeselect.bind(this);
        this.handleDotClick = this.onDotClick.bind(this);

        if (!this.list) return;

        this.mobileMedia.addEventListener('change', this.handleBreakpoint);
        this.list.addEventListener('scrollend', this.handleScrollEnd);
        this.dotsContainer?.addEventListener('click', this.handleDotClick);
        document.addEventListener('visibilitychange', this.handleVisibility);
        document.addEventListener('shopify:block:select', this.handleBlockSelect);
        document.addEventListener('shopify:block:deselect', this.handleBlockDeselect);
        this.setup();
      }

      disconnectedCallback() {
        this.stopAutoplay();
        clearTimeout(this.resetTimer);

        if (!this.list) return;

        this.mobileMedia.removeEventListener('change', this.handleBreakpoint);
        this.list.removeEventListener('scrollend', this.handleScrollEnd);
        this.dotsContainer?.removeEventListener('click', this.handleDotClick);
        document.removeEventListener('visibilitychange', this.handleVisibility);
        document.removeEventListener('shopify:block:select', this.handleBlockSelect);
        document.removeEventListener('shopify:block:deselect', this.handleBlockDeselect);
      }

      setup() {
        this.stopAutoplay();
        clearTimeout(this.resetTimer);

        if (!this.mobileMedia.matches) {
          this.removeClone();
          this.list.scrollLeft = 0;
          this.updateDots(0);
          return;
        }

        this.items = Array.from(this.list.querySelectorAll('.trust-usp-bar__item:not([data-trust-usp-clone])'));
        if (this.items.length < 2) return;

        this.createClone();
        this.updateDots(0);
        this.startAutoplay();
      }

      createClone() {
        if (this.list.querySelector('[data-trust-usp-clone]')) return;

        const clone = this.items[0].cloneNode(true);
        clone.setAttribute('data-trust-usp-clone', '');
        clone.setAttribute('aria-hidden', 'true');
        clone.removeAttribute('id');
        clone.removeAttribute('data-shopify-editor-block');
        clone.querySelectorAll('a, button, input, select, textarea, [tabindex]').forEach((element) => {
          element.setAttribute('tabindex', '-1');
        });
        this.list.appendChild(clone);
      }

      removeClone() {
        this.list.querySelector('[data-trust-usp-clone]')?.remove();
      }

      startAutoplay() {
        if (!this.mobileMedia.matches || this.reducedMotion.matches || document.hidden || this.items.length < 2) return;

        this.stopAutoplay();
        this.autoplayTimer = window.setInterval(() => this.next(), this.autoplaySpeed);
      }

      stopAutoplay() {
        window.clearInterval(this.autoplayTimer);
      }

      next() {
        const slideWidth = this.list.clientWidth;
        if (!slideWidth) return;

        const currentIndex = Math.round(this.list.scrollLeft / slideWidth);
        const nextIndex = currentIndex + 1;
        this.updateDots(nextIndex % this.items.length);
        this.list.scrollTo({ left: nextIndex * slideWidth, behavior: 'smooth' });

        if (nextIndex >= this.items.length) {
          clearTimeout(this.resetTimer);
          this.resetTimer = window.setTimeout(() => this.resetToStart(), 650);
        }
      }

      onScrollEnd() {
        if (!this.mobileMedia.matches || !this.items?.length) return;

        const currentIndex = Math.round(this.list.scrollLeft / this.list.clientWidth);
        if (currentIndex >= this.items.length) {
          this.resetToStart();
        } else {
          this.updateDots(currentIndex);
        }
      }

      resetToStart() {
        clearTimeout(this.resetTimer);
        this.list.style.scrollBehavior = 'auto';
        this.list.scrollLeft = 0;
        this.updateDots(0);
        requestAnimationFrame(() => this.list.style.removeProperty('scroll-behavior'));
      }

      updateDots(activeIndex) {
        this.dots.forEach((dot, index) => {
          const isActive = index === activeIndex;
          dot.classList.toggle('is-active', isActive);
          if (isActive) {
            dot.setAttribute('aria-current', 'true');
          } else {
            dot.removeAttribute('aria-current');
          }
        });
      }

      onDotClick(event) {
        const dot = event.target.closest('[data-trust-usp-dot]');
        if (!dot || !this.mobileMedia.matches) return;

        const selectedIndex = Number(dot.dataset.trustUspDot);
        this.stopAutoplay();
        this.updateDots(selectedIndex);
        this.list.scrollTo({ left: selectedIndex * this.list.clientWidth, behavior: 'smooth' });
        this.startAutoplay();
      }

      onVisibilityChange() {
        if (document.hidden) {
          this.stopAutoplay();
        } else {
          this.startAutoplay();
        }
      }

      onBlockSelect(event) {
        const selectedItem = event.target.closest('.trust-usp-bar__item');
        if (!selectedItem || !this.contains(selectedItem) || !this.mobileMedia.matches) return;

        this.stopAutoplay();
        const selectedIndex = this.items.indexOf(selectedItem);
        if (selectedIndex >= 0) {
          this.updateDots(selectedIndex);
          this.list.scrollTo({ left: selectedIndex * this.list.clientWidth, behavior: 'smooth' });
        }
      }

      onBlockDeselect(event) {
        if (this.contains(event.target)) this.startAutoplay();
      }
    }

    customElements.define('trust-usp-slider', TrustUspSlider);
  }

  } catch(e) { console.error(e); }
})();
})();
